import AutocompleteFormComponent, {
    defaultRenderOption,
    TDefaultAutocompleteOption,
} from "components/shared/FormComponent/AutocompleteFormComponent";
import TextFormComponent from "components/shared/FormComponent/TextFormComponent";
import ModalBase from "components/shared/ModalBase";
import StyledButton from "components/shared/StyledButton";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "store/store";

import LocaleAutocomplete from "../LocaleAutocomplete";
import styles from "./style.module.scss";

interface ISelectTranslationModal {
    originalName: string;
    open: boolean;
    onClose: () => void;
    handleSelect: ({ option, translation }: { option: string | null; translation: string }) => void;
    currentSelection: string[];
    nameLabel: string;
}

/**
 * Select element translation modal
 */
const SelectTranslationModal = ({
    originalName,
    open,
    onClose,
    handleSelect,
    currentSelection,
    nameLabel,
}: ISelectTranslationModal) => {
    const [t] = useTranslation();
    const [locale, setLocale] = useState<string | null>(null);
    const [translation, setTranslation] = useState<string>("");

    const handleValidate = () => {
        onClose();
        handleSelect({ option: locale, translation });
        setTranslation("");
        setLocale(null);
    };

    const titleFieldLabel = locale ? nameLabel + " - " + t(`Locales.${locale}`) : nameLabel;

    return (
        <ModalBase open={open} onClose={onClose} modalTitle={t("NewTitle.AddTranslation")}>
            <div className={styles["select-translation-modal"]}>
                <div className={styles["modal-infos"]}>
                    <span className={styles["info-text"]}>{t("NewTitle.OriginalTitle", { label: nameLabel })}</span>
                    <span className={styles["original-name"]}>{originalName ?? t("NewTitle.NoTitle")}</span>
                </div>
                <LocaleAutocomplete
                    label={t("NewTitle.Lang")}
                    placeholder={t("NewTitle.ChooseLang")}
                    onChange={(e, data) => setLocale(data)}
                    currentSelection={currentSelection}
                />
                <TextFormComponent
                    label={titleFieldLabel}
                    placeholder={t("NewTitle.TitleHereLabel", { label: nameLabel.toLowerCase() })}
                    onChange={(e) => setTranslation(e.target.value)}
                />
                <StyledButton onClick={handleValidate} buttonType="primary" disabled={!locale}>
                    {t("NewTitle.Validate")}
                </StyledButton>
            </div>
        </ModalBase>
    );
};

export default SelectTranslationModal;
